import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, Loader } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PrivacyPage() {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API}/privacy`)
      .then(r => setContent(r.data.content))
      .catch(() => setContent("No se pudo cargar la política de privacidad."))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#F5EEDB] px-4 py-8">
      <div className="max-w-2xl mx-auto">
        <button
          onClick={() => (window.history.length > 1 ? navigate(-1) : navigate("/"))}
          className="flex items-center gap-2 text-[#5B3E2E]/60 hover:text-[#5B3E2E] mb-6"
          data-testid="privacy-back-btn"
        >
          <ArrowLeft size={18} />
          <span className="text-sm">Volver</span>
        </button>
        <h1 className="font-heading text-2xl text-[#5B3E2E] mb-6 font-bold" data-testid="privacy-title">
          Política de Privacidad
        </h1>
        {loading ? (
          <Loader size={24} className="text-[#E48D57] animate-spin mx-auto" />
        ) : (
          <div data-testid="privacy-content" className="bg-[#FDFAF4] rounded-3xl border border-[#5B3E2E]/10 p-6 sm:p-8">
            <pre className="whitespace-pre-wrap font-['Manrope'] text-sm text-[#5B3E2E]/80 leading-relaxed">
              {content}
            </pre>
          </div>
        )}
        <p className="text-xs text-[#5B3E2E]/45 mt-6 text-center">
          También puedes consultar los{" "}
          <Link to="/terms" className="text-[#E48D57] underline">Términos y Condiciones</Link>.
        </p>
      </div>
    </div>
  );
}
